export const SET_VEHICLE = 'SET_VEHICLE';
export const SET_VEHICLE_PURCHASE_METHODS = 'SET_VEHICLE_PURCHASE_METHODS';

export default {
    SET_VEHICLE,
    SET_VEHICLE_PURCHASE_METHODS,
};



// WEBPACK FOOTER //
// ./src/Vehicle/actions/vehicleActionTypes.js